import type { _RouteLocationBase } from 'vue-router'

const TaskDetailsView = async () => import('@/views/task/TaskDetailsView.vue')

/** @type {import('vue-router').RouteRecordRaw[]} */
export default [
  {
    path: '/task/:id',
    name: 'task_details',
    component: TaskDetailsView,
    meta: { title: 'Anfragenverwaltung' },
    props: (
      route: _RouteLocationBase
    ): {
      id: string
    } => {
      return { id: route.params.id as string }
    }
  }
]
